export const getOrganizationDataFromStrapi = (organizationsData: any[], currentOrganization:string) => {
	const isOrganizationArray = Array.isArray(organizationsData)
	const _currentOrganizationData = isOrganizationArray && organizationsData?.find((organizationData: any) => organizationData.attributes.key === currentOrganization)
	return {
		id: _currentOrganizationData?.id,
		..._currentOrganizationData?.attributes
	}
}
